export default __webpack_public_path__ + "locales/pt-BR/FormFillingTipsDialog.json?hash=1f9512f07249c16ca5d3f71ec407f392";